import { setLogString } from "./frontend-log";

let socket = null;
export function connectTaskWS(taskId) {
  if (socket && (socket.readyState === WebSocket.OPEN || socket.readyState === WebSocket.CONNECTING)) {
    socket.close();
  }

  const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://';
  const wsUrl = `${protocol}${window.location.host}/ws/task/${taskId}/`;
  socket = new WebSocket(wsUrl);

  socket.onopen = function(e) {
    console.log("WS connected");
  };

  socket.onmessage = function(e) {
    const data = JSON.parse(e.data);
    if (data.type === 'task_update') {
      document.getElementById('checked-emails').textContent = data.checked_emails;
      document.getElementById('valid-emails').textContent = data.valid_emails;
      document.getElementById('invalid-emails').textContent = data.invalid_emails;
      console.log("status:", data.status);
    }
    if (data.type === 'log_update') {
      console.log(data);
      setLogString(data.log_str);
    }
  };

  socket.onclose = function(e) {
    console.log("WS disconnected");
  };
}